import React, { Fragment } from 'react';
import { getPagePath } from '@spotahome/bff/client';
import { getLoggedInUserInfo } from '@spotahome/soyuz-auth-client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { LoginButton as LoginButtonComponent } from '@spotahome/ui-library';

import '@spotahome/ui-library/lib/components/Dropdown.css';
import '@spotahome/ui-library/lib/components/DropdownItem.css';
import '@spotahome/ui-library/lib/components/MobileMenu.css';
import '@spotahome/ui-library/lib/components/Header.css';
import '@spotahome/ui-library/lib/components/LoginButton.css';

import './LoginModalStyles';

import { TOKEN_EXPIRED } from '../../channels';

import withModalProps from './withModalProps';

const SESSION_EXPIRED_STATUS = 401;

async function requestLoggedInUserInfo() {
  try {
    const response = await getLoggedInUserInfo();
    return response;
  } catch (err) {
    if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
      Mediator.publish(TOKEN_EXPIRED);
    } else {
      throw new Error(err);
    }
  }
}

const LoginButton = props => (
  <LoginButtonComponent
    color={props.hasDarkBackground ? 'light' : 'dark'}
    logoutPath="/marketplace/logout"
    getLoggedInUserInfo={requestLoggedInUserInfo}
    modalProps={props.modalProps}
    typeMenu="menu-white"
    userAreaPath={getPagePath('externals.my-requests')}
    searchPreferencePath={getPagePath(
      'externals.landing-pages.search-preferences'
    )}
    myProfilePath={getPagePath('externals.my-profile')}
    isMobile={props.isMobile}
  />
);

export default withModalProps()(LoginButton);
